import script from "./CreateTrainerSessionModalV2.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateTrainerSessionModalV2.vue?vue&type=script&setup=true&lang=js"

import "./CreateTrainerSessionModalV2.vue?vue&type=style&index=0&id=229f5be6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-229f5be6"]])

export default __exports__